import React, { Component } from 'react'
import { connect } from 'react-redux'
var RPCLoader = null
try {
  RPCLoader = require('../../projects/' + process.env.REACT_APP_PROJECT + '/components/core/RPCLoader').default
} catch (e) {}

class Header extends Component {
  toggleSidebarState () {
    this.props.dispatch({
      type: 'SET_SIDEBAR_STATE',
      payload: !this.props.sidebar
    })
  }
  toggleToolbarState () {
    this.props.dispatch({
      type: 'SET_TOOLBAR_STATE',
      payload: !this.props.toolbar
    })
  }
  render () {
    return (
      <nav className='navbar navbar-fixed-top navbar-default'>
        <div className='container-fluid'>
          <div className='navbar-header'>
            <a className='navbar-brand' id='home_button_brand' href='/#/'><img src='/static/maintrac.svg' width='35' height='35' /><span>Flow</span></a>
          </div>
          <ul className='nav navbar-nav navbar-nav-first'>
            <li>
              <a className='header-button' onClick={(e) => this.toggleSidebarState()}><i className='fa fa-bars' /></a>
            </li>
            { RPCLoader && <RPCLoader /> }
            {this.props.developer && <li>
              <a className='header-button'><span className='label label-default'><i className='fa fa-warning' /> Developer mode is active</span></a>
            </li>}

          </ul>
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a className='header-button' onClick={(e) => this.toggleToolbarState()}><i className='fa fa-user' /></a>
            </li>
          </ul>
          {!!this.props.searchComponent && <this.props.searchComponent />}
        </div>
      </nav>
    )
  }
}
// eslint-disable-next-line
Header = connect(state => state.siteReducer)(Header)
export default Header



// WEBPACK FOOTER //
// ./src/components/core/Header.js